export const MEETING_PREP = {
  id: 'demo-skl-meeting-prep',
  title: 'Meeting prep',
  description:
    'Everything you need before a meeting: who’s coming, what was said last time, open threads, and what you want out of it.',
  apps: ['Google Calendar', 'Gmail', 'HubSpot'],
  usedCount: 31,
  lastUsedMinutesAgo: 5 * 60 + 12,
  instructions: `**For the meeting named (or the next one on my calendar):**

1. List attendees with role and company. Mark anyone I haven't met.
2. Summarise the last email thread and the last meeting notes with these people.
3. Pull the HubSpot deal stage, amount, and next step if there is one.
4. List open questions or promises either side made and hasn't closed.
5. Suggest one goal for the meeting and three questions that move toward it.

**Format:** short sections with bold labels. Keep it under 250 words.`,
  examples: ['Prep me for my 2pm', 'Prep for tomorrow’s call with Northwind'],
}
